import {
  AccountApprovalsRequest,
  AccountApprovalsResponse,
} from "@services/models/Affiliate/AccountApprovalsModel";
import {
  ApproveMerchantRequest,
  ApproveMerchantResponse,
} from "@services/models/Affiliate/ApproveMerchantModel";
import {
  GetAffiliatesRequest,
  GetAffiliatesResponse,
} from "@services/models/Affiliate/GetAffilatesModel";
import {
  GetAffiliateMerchantsRequest,
  GetAffiliateMerchantsResponse,
} from "@services/models/Affiliate/GetAffiliateMerchantsModel";
import {
  GetMerchantCommisionsRequest,
  GetMerchantCommisionsResponse,
} from "@services/models/Affiliate/GetMerchantCommisionsModel";
import {
  MerchantApprovalsRequest,
  MerchantApprovalsResponse,
} from "@services/models/Affiliate/MerchantApprovalMappingModel";
import {
  UpdateApprovalStatusRequest,
  UpdateApprovalStatusResponse,
} from "@services/models/Affiliate/UpdateApprovalStatusModel";
import { UpdateMerchantCommisionResponse } from "@services/models/Affiliate/UpdateMerchantCommisionModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class AffiliateApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getAccountApprovals(
    data: AccountApprovalsRequest
  ): Promise<AccountApprovalsResponse> {
    try {
      const response = await this.api.get("/adminPanel/affiliate/requests", {
        params: {
          page: data.page,
          limit: data.limit,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getMerchantApprovals(
    data: MerchantApprovalsRequest
  ): Promise<MerchantApprovalsResponse> {
    try {
      const response = await this.api.get(
        "/adminPanel/affiliate/merchant/requests",
        {
          params: {
            page: data.page,
            limit: data.limit,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getAffiliates(
    data: GetAffiliatesRequest
  ): Promise<GetAffiliatesResponse> {
    try {
      const response = await this.api.get("/adminPanel/affiliate", {
        params: {
          page: data.page,
          limit: data.limit,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getMerchantAffiliates(
    data: GetAffiliateMerchantsRequest
  ): Promise<GetAffiliateMerchantsResponse> {
    try {
      const response = await this.api.get(
        `adminPanel/affiliate/mapped/merchant/${data.id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getMerchantCommisions(
    data: GetMerchantCommisionsRequest
  ): Promise<GetMerchantCommisionsResponse> {
    try {
      const response = await this.api.get(
        `adminPanel/affiliate/mapped/merchant/commission/${data.id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async updateMerchantCommision(
    data: any
  ): Promise<UpdateMerchantCommisionResponse> {
    try {
      const response = await this.api.put(
        "adminPanel/affiliate/mapped/merchant/commission",
        {
          data: data,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async updateAccountApprovalRequest(
    data: UpdateApprovalStatusRequest
  ): Promise<UpdateApprovalStatusResponse> {
    try {
      const response = await this.api.post(`/adminPanel/affiliate/${data.id}`, {
        status: data.status,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async approveMerchant(
    data: ApproveMerchantRequest
  ): Promise<ApproveMerchantResponse> {
    try {
      const response = await this.api.post(
        `/adminPanel/affiliate/merchant/${data.id}`,
        {
          status: data.status,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const affiliateApis = new AffiliateApiService();
